import { initFolders } from './folders';
import { initItems } from './items';
import { initFolder } from './folder';
import { extendDeep, get } from '../../utils/utils';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { initRefreshTokenWrapper } from './refresh-token-wrapper';
import { initHttp } from '../../utils/http';
import { oldMediaManagerFolder } from './data/folders';
import { defaultSettings } from '../private-site/settings';
import { initFolders as initPrivateSiteFolders } from '../private-site/folders';
import { initItems as initPrivateSiteItems } from '../private-site/items';
import { initFolder as initPrivateSiteFolder } from '../private-site/folder';
import { initItems as initWixVideoItems } from '../wix-video/items';
export function WixSite(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  if (!userSettings.siteMediaToken) {
    throw new Error('siteMediaToken param is missing');
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep({
    requestOptions: {
      params: {
        site_token: userSettings.siteMediaToken
      }
    }
  }, defaultSettings, userSettings);
  const withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
  const requestOptions = settings.requestOptions;
  if (get(requestOptions, 'params.ns')) {
    settings.ns = requestOptions.params.ns;
  }
  const http = initHttp(requestOptions);
  const settingsWithRefreshToken = {
    get: withRefreshToken(http.get),
    post: withRefreshToken(http.post),
    upload: withRefreshToken(http.upload)
  };
  const httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;
  const privateSiteFolders = initPrivateSiteFolders(settings, http);
  const privateSiteItems = initPrivateSiteItems(settings, http);
  const privateSiteFolder = initPrivateSiteFolder(settings, http);
  const wixVideoItems = initWixVideoItems(settings, httpWithRefreshToken);
  const folders = initFolders(settings, httpWithRefreshToken, privateSiteFolders, wixVideoItems);
  const items = initItems(settings, httpWithRefreshToken, privateSiteItems, wixVideoItems);
  const folder = initFolder(settings, httpWithRefreshToken, privateSiteFolder);
  this.name = 'wix-site';
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.folder = addEvents(this, eventsList.FOLDER, folder);
}
WixSite.oldMediaManagerFolder = oldMediaManagerFolder;